import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface IdentityAuthState {
  isAuthenticated: boolean;
}

@Injectable({ providedIn: 'root' })
export class PGHIdentityAuthStateService {
  private readonly authStateSubject = new BehaviorSubject<IdentityAuthState>({ isAuthenticated: false });

  readonly authState$: Observable<IdentityAuthState> = this.authStateSubject.asObservable();

  setAuthenticated(isAuthenticated: boolean): void {
    this.authStateSubject.next({ isAuthenticated });
  }

  isTokenValid(): boolean {
    return this.authStateSubject.value.isAuthenticated;
  }
}
